import {formatDateAndTime, serverLink} from "../../url";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Loader from "../../common/loader";
import DataTable from "../../common/data-table/data-table";
import {connect} from "react-redux";
import {showConfirm} from "../../common/sweetalert/sweetalert";
import {toast} from "react-toastify";

    const PatientAllergies = ({patientSerial, loginData, handleRemount}) => {
    const token = loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(true)
    const [allergyList, setAllergyList] = useState([])
    const header = ["S/N", "Allergy Name", "Medication", "Last Attack Date",  "Duration Before Subsiding", "Description", "Reaction Image", "Action"];

    useEffect( () => {
        getData();
    }, [handleRemount]);

    const getData = async () => {
        setIsLoading(true)
        await axios.get(`${serverLink}patient/allergy/list/${patientSerial}`, token)
            .then((result) => {
                if (result.data.length > 0) {
                    setAllergyList(result.data);
                }else {
                    setAllergyList([])
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }
    const  showTable = () => {
        try {
            return allergyList.length > 0 &&  allergyList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index +1}</td>
                        <td>{item.allergyName}</td>
                        <td>{item.allergyMedication}</td>
                        <td>{formatDateAndTime(item.lastAttackDate, 'date')}</td>
                        <td>{item.durationBeforeSubsiding}</td>
                        <td>{item.allergyDescription}</td>
                        <td><img src={`${serverLink}public/uploads/allergy_uploads/${item.reactionImage}`} width={80} height={80} className="img-thumbnail" alt=""/></td>
                        <td>
                            <a href="#" className={"btn btn-danger btn-sm "}
                               onClick={() => {
                                   showConfirm("Warning", `Are you sure you want to delete this record?`, "warning")
                                       .then( async (confirm) => {
                                           if (confirm) {
                                               delete_item(item.allergyID)
                                           }
                                       })
                               }}>
                                Delete
                            </a></td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

        const delete_item = async (id) => {
            toast.info("please wait...");
            await axios.delete(`${serverLink}patient/allergy/delete/${id}`).then((res) => {
                if (res.data.message === "success") {
                    toast.success("Deleted Successfully");
                    getData();
                } else {
                    toast.error("NETWORK ERROR. Please try again!");
                }
            }).catch((err) => {
                console.log(err);
                toast.error("NETWORK ERROR. Please try again!");
            });
        }

    return (IsLoading ? <Loader/> :
            <div className="">
                <div className="table-responsive">
                    <h5 className="card-title">Patient Allergies</h5>
                    <DataTable tableID="patient-allergy" header={header} body={showTable()} title="Patient Allergies Report"/>
                </div>
            </div>
    )
}
const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(PatientAllergies);

